import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../../global/mediaQueryMixin';

const Content = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  width: 100%;
  ${mobile_xl(css`
    margin-top: var(--space-8);
  `)}
`;

export { Content };
